/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';
import { Configuration, PopupRequest } from "@azure/msal-browser";

/**
 * Enter here the user flows and custom policies for your B2C application
 * To learn more about user flows, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/user-flow-overview
 * To learn more about custom policies, visit: https://docs.microsoft.com/en-us/azure/active-directory-b2c/custom-policy-overview
 */
export const b2cPolicies = {
    names: {
        signUpSignIn: process.env.REACT_APP_USER_POLICY,
        forgotPassword: 'B2C_1_reset_v3',
        editProfile: 'B2C_1_edit_profile_v2',
    },
    authorities: {
        signUpSignIn: {
            authority: process.env.REACT_APP_AUTHORITY,
        },
        forgotPassword: {
            authority: process.env.REACT_APP_AUTHORITY,
        },
        editProfile: {
            authority: 'https://ltlb2ctest.b2clogin.com/ltlb2ctest.onmicrosoft.com/b2c_1_edit_profile_v2',
        },
    },
    authorityDomain: process.env.REACT_APP_KNOWN_AUTHORITIES,
};

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
    auth: {
      
        clientId: process.env.REACT_APP_CLIENT_ID,
        authority: process.env.REACT_APP_AUTHORITY,
        state: process.env.REACT_APP_STATE,
        clientSecret: process.env.REACT_APP_CLIENT_SECRET,
        grantType: process.env.REACT_APP_GRANT_TYPE,
        knownAuthorities: [process.env.REACT_APP_KNOWN_AUTHORITIES],
        redirectUri: process.env.REACT_APP_REDIRECT_URI,
        postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
        navigateToLoginRequestUrl: process.env.REACT_APP_NAVIGATE_TO_LOGIN_REQUEST_URL === 'true',
    },
    cache: {
        cacheLocation: 'localStorage', // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case LogLevel.Error:
                        console.error(message);
                        return;
                    case LogLevel.Info:
                        console.info(message);
                        return;
                    case LogLevel.Verbose:
                        console.debug(message);
                        return;
                    case LogLevel.Warning:
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            },
        },
    },
};

export const tenantDomain = process.env.REACT_APP_TENANT_NAME;

export const userPermissionScopes = [
    "https://" + tenantDomain + "/" + process.env.REACT_APP_CLIENT_ID + "/Reports.Embed",
];
export const AppOwnsDataApiPermissionScopes = [
    "https://" + tenantDomain + "/" + process.env.REACT_APP_CLIENT_ID + "/Reports.Embed",
    "email"
]
export const PowerBiLoginRequest = {
    scopes: userPermissionScopes,
};
/**
 * Scopes you add here will be prompted for user consent during sign-in.
 * By default, MSAL.js will add OIDC scopes (openid, profile, email) to any login request.
 * For more information about OIDC scopes, visit:
 * https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent#openid-connect-scopes
 */

export const loginRequest = {
  scopes: ['openid offline_access ' + process.env.REACT_APP_SCOPE],
};
